/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const GraceBehavior = {
    FreeThenFullRate: 'FreeThenFullRate',
    RoundDownToZero: 'RoundDownToZero',
    Discounted: 'Discounted'
} as const;
export type GraceBehavior = typeof GraceBehavior[keyof typeof GraceBehavior];

